import * as React from 'react';

function SvgPlusFilled(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={15} cy={15} r={11} fill="#414B56" />
      <path
        d="M15 9.077a.48.48 0 00-.48.48l-.004 4.959-4.959.004a.48.48 0 000 .96l4.967-.004-.004 4.966a.48.48 0 10.96.001V15.48h4.964a.48.48 0 10-.001-.96l-4.967.004.004-4.966a.48.48 0 00-.48-.481z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPlusFilled;
